import useConfig from 'AppShell/hooks/useConfig';
import { useMemo } from 'react';
import { sourceByCountryCode } from 'OneWestwingFooter/common/Flag';

export interface CountryLink {
    link: string;
    poKey: string;
    src: string;
    code: string;
}

const bellaCountryLinks = {
    de: 'https://www.westwing.de/',
    ch: 'https://www.westwing.ch/',
    fr: 'https://www.westwing.fr/',
    it: 'https://www.westwing.it/',
    es: 'https://www.westwing.es/',
    nl: 'https://www.westwing.nl/',
    pl: 'https://www.westwing.pl/',
    sk: 'https://www.westwing.sk/',
    cz: 'https://www.westwing.cz/',
};
const clubCountryLinks = {
    de: 'https://www.westwing.de/c/',
    ch: 'https://www.westwing.ch/c/',
    fr: 'https://www.westwing.fr/c/',
    it: 'https://www.westwing.it/c/',
    es: 'https://www.westwing.es/c/',
    nl: 'https://www.westwing.nl/c/',
    pl: 'https://www.westwing.pl/c/',
    sk: 'https://www.westwing.sk/c/',
    cz: 'https://www.westwing.cz/c/',
};

export const useCountrySelectorLinks = (isClub: boolean): CountryLink[] => {
    const { currentCountry } = useConfig();

    const sortedLinks = useMemo(() => {
        const countries = isClub ? clubCountryLinks : bellaCountryLinks;
        const countryLinks: CountryLink[] = [
            { link: countries.de, code: 'de', poKey: 'Germany', src: sourceByCountryCode.de },
            { link: countries.ch, code: 'ch', poKey: 'Switzerland', src: sourceByCountryCode.ch },
            { link: countries.fr, code: 'fr', poKey: 'France', src: sourceByCountryCode.fr },
            { link: countries.it, code: 'it', poKey: 'Italy', src: sourceByCountryCode.it },
            { link: countries.es, code: 'es', poKey: 'Spain', src: sourceByCountryCode.es },
            { link: countries.nl, code: 'nl', poKey: 'Netherlands', src: sourceByCountryCode.nl },
            { link: countries.pl, code: 'pl', poKey: 'Poland', src: sourceByCountryCode.pl },
            { link: countries.sk, code: 'sk', poKey: 'Slovakia', src: sourceByCountryCode.sk },
            { link: countries.cz, code: 'cz', poKey: 'Czech Republic', src: sourceByCountryCode.cz },
        ];

        const currentCountryIndex = countryLinks.findIndex(({ code }) => code === currentCountry);
        const currentCountryLink = countryLinks[currentCountryIndex];
        countryLinks.splice(currentCountryIndex, 1);
        countryLinks.unshift(currentCountryLink);

        return countryLinks;
    }, [currentCountry, isClub]);

    return sortedLinks;
};
